import React from 'react'
import { useBuildHpSupportLink } from '../hooks/useBuildHpSupportLink'

const HPSupportSpecificLink = ({ children }) => {
  const { hpSupportProduct } = useBuildHpSupportLink()

  if (!hpSupportProduct) {
    return <>{children}</>
  }

  return (
    <a href={hpSupportProduct} target="_blank" rel="noreferrer">
      {children}
    </a>
  )
}

export default HPSupportSpecificLink
